export const FONT_SIZE = ['8px', '9px', '10px', '12px', '14px', '16px', '20px', '24px', '32px'];

export const HEADINGS = [
	'Heading 1',
	'Heading 2',
	'Heading 3',
	'Heading 4',
	'Heading 5',
	'Heading 6',
];

export const FONT_CSS_MAP = {
	arial: 'Arial, sans-serif',
	helvetica: 'Helvetica, sans-serif',
	verdana: 'Verdana, sans-serif',
	tahoma: 'Tahoma, sans-serif',
	'trebuchet-ms': 'Trebuchet MS, sans-serif',
	georgia: 'Georgia, serif',
	'times-new-roman': 'Times New Roman, serif',
	'courier-new': 'Courier New, monospace',
	'lucida-sans-unicode': 'Lucida Sans Unicode, sans-serif',
	impact: 'Impact, sans-serif',
	'palatino-linotype': 'Palatino Linotype, serif',
	calibri: 'Calibri, Carlito, sans-serif',
	// muli: 'Muli, Mulish, sans-serif',
};
